// extracted by mini-css-extract-plugin
export default {"eye":"YOeJVNv+VU3f+nMsM+JfpQ==","maxCounter":"cZU6GgPYEo75jEq3SQ1PoQ==","icons":"a2iX4+LrQJOqRX3+N2crtg=="};